/**
 * 対象者（ターゲットオーディエンス）の型定義とビジネスロジック
 */

/**
 * 対象者の種類（任意講座用）
 */
export type TargetAudience =
  | '企業'
  | '企業事例'
  | '教育機関'
  | '教育機関事例'
  | '自治体'
  | '自治体事例';

/**
 * 対象者グループ（表示用）
 */
export type TargetAudienceGroup = '企業編' | '教育機関編' | '自治体編';

/**
 * 対象者からグループを取得
 */
export const getAudienceGroup = (
  audience: TargetAudience
): TargetAudienceGroup => {
  if (audience.startsWith('企業')) return '企業編';
  if (audience.startsWith('教育機関')) return '教育機関編';
  if (audience.startsWith('自治体')) return '自治体編';
  throw new Error(`Unknown target audience: ${audience}`);
};

/**
 * グループ表示順序
 */
export const AUDIENCE_GROUP_ORDER: readonly TargetAudienceGroup[] = [
  '自治体編',
  '企業編',
  '教育機関編',
] as const;

/**
 * グループ内での対象者表示順序
 */
export const AUDIENCE_ORDER_IN_GROUP: Record<
  TargetAudienceGroup,
  readonly TargetAudience[]
> = {
  企業編: ['企業', '企業事例'],
  教育機関編: ['教育機関', '教育機関事例'],
  自治体編: ['自治体', '自治体事例'],
} as const;
